  // @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

export type Props = {
  tags: Array<{
    id: number,
    name: string,
    slug: string,
    source: string,
  }>
};

class ArticleTags extends PureComponent<Props>{
  static defaultProps = {
    tags: []
  };

  renderTags = () => {
    const { tags } = this.props;
    return tags.map<any>((t, index) => {
			const linkTo = t.source === 'categorie' ? `/actualites/${t.slug}` : `/tags/${t.slug}`;
			return (
				<li key={t.slug}>
					<Link to={linkTo}>
						<span className="tag">
							{t.name}
						</span>
					</Link>
				</li>
    	);
		});
  };

  render(){
    return(
      <React.Fragment>
        <h3 className="mt-md-3 mt-lg-5 mb-3">Dans cet article</h3>
        <ul className="list-tag mb-3">{this.renderTags()}</ul>
      </React.Fragment>
    );
  }
}

export default ArticleTags;
